export const guiConfig = {
  url: {
    weixinUrl: 'https://wechat.dianyixueyuan.com',
    backUrl: '/xboot'
  },
  codeKey: "MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBAL7fFOFrZH9HGUp8KNIXAYTZnqehrE2t95r3wUf9IgW3rqOWl0EXufr4Dr0w9ut9GJXJfJtrqturfrvB0eeK3x88mWS62nMzpeDFtCecAe0wdqFmwvZrp5KryEFMkghJp0cAjupNcUuDcHiKTWVqAszgYgNIU0p6zzDmaWHmAOENAgMBAAECgYASKLEY3Rm7ji0WzAcqLawkUnvooNX+se1bnfSSf7+r4ZTI1XvgYnx8Jvtn/m+PaeBb58ZmFvEzYvZ0sHTi3XBqovOKybNp5x648oBTALFSs/ueV8x30wlcKph/vSE1PssNEmtgZbp6i5Nelr+yNmzbxNBkYJY0nFQ8ZrUZa9e2dQJBAPvAhyYSdlGWUj0PmK9TlXREjwpdg9Aav8DXj1IdoKvn5csWNJJfYC448+OSirAuFW1J4jXeGOGK9l324b5QvJ8CQQDCF5KZKotqmIZ6I1ONnfwz/b/wdg0CENGbDdVDS3Q4m7SUVuKaeX+s1twPYFzq5Jkpbbp3uavZXX2f/ovG6FbTAkB+V777smRCycf38O3Vf4MP2KBYuVm/hM0bAJNiyI+r9jNy2nADzW29hMORQCfuBxKlyGCIXC/scQr3WUEte+NNAkEAoTEqkwH+XzzlEjKchZSbjCJFcdLY4spNCdTnNMhJcWn/AuNVtq0JF+YpRKvm/z1y5jE3F4+f5Rn75xBjzYHP+QJBAJ07Vjiia6F0/KZdw671bKNL0S3d+lgRHX/NkMhuXCcRRldJ2D/I7cfITKYykjlpGjq3rrm4dBTROsf7VM9hvKQ=",
  // url: {
  //   weixinUrl: 'https://xiongbangzhu.dianyixueyuan.com/showScratchOpus/',
  //   backUrl: '/xboot'
  // }
  backUrl_v1: 'https://dev.dianyixueyuan.com', // a
}



// WEBPACK FOOTER //
// ./src/config.js